import React, { useEffect, useState } from "react"
import Images from "../../commonComponents/Images/Images"
import BookADemoModal from "./BookADemoModal";

const HomeBanner = () => {

    const [moveIn, setMoveIn] = useState(false);
    const [animate, setAnimate] = useState(true);
    const [demoModalShow, setDemoModalShow] = useState(false);
    const [activeSlide, setActiveSlide] = useState(0);
useEffect(() => {
  const interval = setInterval(() => {
    setActiveSlide((prev) => (prev + 1) % 5);
  }, 3000);

  return () => clearInterval(interval);
}, []);


    const bannerImages = {
        img1: Images.ABDM,
        img2: Images.AWS,
        img3: Images.leftImg,
        img4: Images.centerImg,
        img5: Images.rightImg,
    }

    useEffect(() => {
        setMoveIn(true);

        const timer = setTimeout(() => {
            setAnimate(false);
        }, 5000);

        return () => clearTimeout(timer);
    }, [])

    return (
        <>
            <section id="home">
                <div className="homeBanner-section mxy-40 pxy-80 mt-0">
                    <div className="container">
                        <div className="row row-25 align-items-center banner-content">
                            <div className="col-lg-6 col-md-12 col-sm-12 banner-content">
                               <div className="carousel-wrapper overflow-hidden mb-4">
                                    <div className="carousel-wrapper overflow-hidden mb-4">
                                <div
                                    className="carousel-track"
                                    style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                                >
                                    <div className="slide"><h3 className="mb-0 text-start">Smarter Care. Better Adherence. One App</h3></div>
                                    <div className="slide"><h3 className="mb-0 text-start">Stay on track with your care plan.</h3></div>
                                    <div className="slide"><h3 className="mb-0 text-start">Smart reminders, easy tracking, and clear insights – every day.</h3></div>
                                    <div className="slide"><h3 className="mb-0 text-start">Never miss an important step in your care.</h3></div>
                                    <div className="slide"><h3 className="mb-0 text-start">Get reminders, track progress, and stay informed with ease.</h3></div>
                                </div>

                                {/* DOTS */}
                                <div className="carousel-dots">
                                    <div className={`dot ${activeSlide === 0 ? "active" : ""}`} onClick={() => setActiveSlide(0)} />
                                    <div className={`dot ${activeSlide === 1 ? "active" : ""}`} onClick={() => setActiveSlide(1)} />
                                    <div className={`dot ${activeSlide === 2 ? "active" : ""}`} onClick={() => setActiveSlide(2)} />
                                    <div className={`dot ${activeSlide === 3 ? "active" : ""}`} onClick={() => setActiveSlide(3)} />
                                    <div className={`dot ${activeSlide === 4 ? "active" : ""}`} onClick={() => setActiveSlide(4)} />
                                </div>
                                </div>

                                    </div>

                                <div className="img-div">
                                    <div className="logo-div d-flex gap-20">
                                       
                                      <div>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.digidoc.patient"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                            src={bannerImages.img1}
                                            alt="PlayStore logo"
                                            className="img-fluid"
                                            />
                                        </a>
                                        </div>

                                     <div>
  <a
    href="https://apps.apple.com/in/app/digidoc-user/id6757748327"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src={bannerImages.img2}
      alt="AppStore logo"
      className="img-fluid"
      style={{ cursor: "pointer" }}
    />
  </a>
</div>
                                    </div>
                                </div>
                                {/* <div className="btn-div mt-3">
                                    <button class="btn btn-sm btn-yellow" type="button" onClick={() => setDemoModalShow(true)}>Book a Demo</button>
                                </div> */}
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 row gap-20">
                                <div className="img-div">
                                    <img src={Images.digidoc_logo} className="img-fluid" alt="Digidoc Logo" />
                                </div>
                                <div className={`${moveIn ? 'animation-main-div' : ''} ${!animate ? 'pause-animation' : ''}`}>
                                    <div class="circle"></div>
                                    <div class="circle2"></div>
                                    <div class="circle3"></div>
                                </div>
                                <div className={`img-div d-flex align-items-end justify-content-center image-container ${moveIn ? 'move-in' : ''}`}>
                                    <div id="image-left">
                                        <img src={bannerImages.img3} alt="Left Image" className="img-fluid" />
                                    </div>
                                    <div id="image-center">
                                        <img src={bannerImages.img4} alt="Center Image" className="img-fluid" />
                                    </div>
                                    <div id="image-right">
                                        <img src={bannerImages.img5} alt="Right Image" className="img-fluid" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookADemoModal
                show={demoModalShow}
                onHide={() => setDemoModalShow(false)} />
        </>
    )
}
export default HomeBanner